import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { complaintOptionsProjection } from "../sanity/complaintOptions.projection"

export const queryComplaintAvailableApplications = {
  async complaintAvailableApplications(_parent, args, context, _info) {
    const lang = AppSettings.defaultLocale()
    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: (args.cdn = false) })

    try {
      const availableApplications =
        await client.fetch(groq`*[_type=="complaintAvailableApplications"] | order(name asc){
        ${complaintOptionsProjection()}
      }`)
      return availableApplications
    } catch (error) {
      throw new Error(error)
    }
  },
}
